export default __webpack_public_path__ + "static/0315-fbca8ff784867d7e43bd4a02e481896a.jpg";